/**
 * v5 blok 12 — centrale branding. De definitieve bedrijfs-/domeinnaam is nog
 * niet gekozen; ALLES wat naam, adres of contactgegevens toont hoort uit dit
 * bestand te komen zodat één wijziging hier overal doorwerkt (site, footer,
 * contact, offerte- en factuur-PDF's). Domein + mailadressen worden pas
 * ingesteld bij goedkeuring van de site.
 */
export const BRAND = {
  name: 'Het Gevelsteenbedrijf',
  shortName: 'Gevelsteenbedrijf',
  domain: 'gevelsteenbedrijf.be',        // nog niet definitief
  email: 'info@gevelsteenbedrijf.be',    // nog niet definitief
  phone: '+32 (0)3 123 45 67',           // wettelijk verplicht in de voettekst
  street: 'Bredabaan 123',
  postalCode: '2970',
  city: 'Schilde',
  country: 'België',
  btw: 'BE0123.456.789',
  hours: 'Ma–Vr 8u30–17u00',
} as const;
